// NGLS has not supplied this section's wording yet.
export const nglsTbd = (section: string) => `${section} TBD`;
export const LOSS_DRAFT_TYPE_ID = 15;

export const nglsOn = (config?: { ngls?: boolean } | null) => config?.ngls === true;

export const lossDraftOnly = (typeIds: number[]) =>
  typeIds.length === 1 && typeIds[0] === LOSS_DRAFT_TYPE_ID;

export const usBank = (text: string) => text.replace(/\bUS Bank\b/g, "U.S. Bank");

export const nglsSteps = (on: boolean) =>
  on
    ? ["Transaction Details", "Authorize", nglsTbd("Send Payment")]
    : ["Payment Type", "Transaction Details", "Authorize", "Send Payment"];

export const NGLS_SIGN_THE_CHECK =
  "Please ensure all parties sign the back of the check";

export const nglsCheckInstructions = () => [
  NGLS_SIGN_THE_CHECK,
  nglsTbd("Instruction list"),
];

export const nglsDisclaimerAcceptedBy = (
  first?: string,
  last?: string,
  email?: string
) =>
  [[first, last].filter(Boolean).join(" "), email].filter(Boolean).join(" ");
